<template>
<div>
    <div class="form-group mb-2 text-center">
        <h5 class="mt-2 text-center">Are you sure you want to remove this card?</h5>

        <div v-if="removalMessage" :style="removalMessageStyle" v-html="removalMessage"></div>
    
        <div class="saved" @mouseover="hoverEffect(true, 0)" @mouseleave="hoverEffect(false, 0)" :style="{'borderColor' : (hover && hoverKey == 0) ? `${client_info.colors.app}` : '' }">

            <div class="title mb-1 mt-2 text-left pl-2" @mouseover="hoverEffect(true, 0)" @mouseleave="hoverEffect(false, 0)" :style="{'borderColor' : (hover && hoverKey == 0) ? `${client_info.colors.app}` : '', 'width': '200px','color' : (hover && hoverKey == 0) ? `${client_info.colors.app}` : '' }">
                {{ formatCard(cardToBeRemoved.number.toUpperCase()) }}
            </div>
            <i v-if="['visa', 'mastercard', 'verve'].includes(cardToBeRemoved.scheme.toLowerCase())" :class="cardToBeRemoved.scheme.toLowerCase()"></i>
        </div>
    </div>

    <div class="text-center my-3 mt-4">
        <div id="new-saved" class="switch">
            <a @click.prevent="$emit('cancelCardRemoval')" title="No, Keep Card" class="left active pointer px-4 mr-4" @mouseover="cardRemovalHoverEffect(true, 0)" @mouseleave="cardRemovalHoverEffect(false, 0)" :style="{ 'font-weight': 'bold', 'background' : (cardRemovalActionHover && cardRemovalActionHoverKey ==0) ? `${client_info.colors.app}` : `#ffffff`, 'color' : `${client_info.colors.payment_description} !important`, 'borderColor' : `${client_info.colors.app}`,}">NO</a>

            <a @click.prevent="$emit('removeCard')" title="Yes, Remove Card" class="right active pointer px-3" @mouseover="cardRemovalHoverEffect(true, 1)" @mouseleave="cardRemovalHoverEffect(false, 1)" :style="{ 'font-weight': 'bold', 'background' : (cardRemovalActionHover && cardRemovalActionHoverKey ==1) ? `${client_info.colors.app}` : `#ffffff`, 'border' : `${client_info.colors.primary_button} solid 1px`, 'color' : `${client_info.colors.payment_description} !important`, 'borderColor' : `${client_info.colors.app}`,}"> &nbsp; YES &nbsp;</a>

        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        cards: {
            type: Array,
            required: true,
        },
        client_info: {
            type: Object,
            required: true,
        },
        cardToBeRemoved: {
            type: Object,
            required: true,
        },
        removalMessage:{
            default:'',
            required:false,
            type: String
        }
    },
    data() {
        return {
            hoverKey: 0,
            hoverValue: '',
            hover: false,
            attemptCardRemoval:true,
            cardRemovalActionHover: '',
            cardRemovalActionHoverKey: '',
            removalMessageStyle: {
                'color': '#a94442',
                'background-color': '#f2dede',
                'border-color': '#ebccd1',
                'padding': '5px',
                'margin-bottom': '20px',
                'border': '1px solid transparent',
                'border-radius': '4px',
                'text-align': 'center',
            },
        }
    },
    methods: {
        pickCard(val) {
            this.$emit('selectCard', this.card[val]);
        },
        triggerManageCard() {
            this.$emit('triggerManageCard');
        },
        makePayment() {
            this.$emit('makePayment');
        },
        triggerCardInput() {
            this.$emit('triggerCardInput');
        },
        formatCard(str) {
            str = str.toUpperCase();
            let prefix = str.slice(0, 4),
                prefix2 = str.slice(4, 8),
                prefix3 = str.slice(8, 12),
                suffix = str.slice(10),
                main = `${prefix} ${prefix2} ${prefix3} ${suffix}`;
            return main;
        },
        hoverEffect(value, key) {
            this.hover = value
            this.hoverKey = key
        },

        cardRemovalHoverEffect(value, key) {
            this.cardRemovalActionHover = value
            this.cardRemovalActionHoverKey = key
        },
    },
}
</script>
